import { render, staticRenderFns } from "./download.vue?vue&type=template&id=44debb6c&scoped=true"
import script from "./download.vue?vue&type=script&lang=ts"
export * from "./download.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44debb6c",
  null
  
)

export default component.exports